<template>
  <MainHeader />
  <MainSidebar />
  <div class="main-content bg_gray d-flex flex-column transition overflow-hidden">
    <BreadcrumbMenu pageTitle="create_income" />
    <CreateIncomeForm
      :referenceno="referenceno"
      :date="date"
      :categories="categories"
      :warehouses="warehouses"
      :form="form"
      :is-loading="isLoading"
      :is-edit-mode="isEditMode"
      @update:referenceno="referenceno = $event"
      @update:date="date = $event"
      @update:field="(field, value) => form[field] = value"
      @generate-reference="fetchNextRef"
      @open-category-modal="openCategoryModal"
      @submit="submitIncome"
    />
    <CreateIncomeCategoryModal
      :form="categoryForm"
      :loading="isCategorySaving"
      :is-edit-mode="isCategoryEditMode"
      @update-field="updateCategoryField"
      @generate-code="generateCategoryCode"
      @submit="submitCategory"
    />
    <div class="flex-grow-1"></div>
    <MainFooter />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadcrumbMenu from "../../components/Common/BreadcrumbMenu.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";
import MainHeader from "../../components/Layouts/MainHeader.vue";
import MainSidebar from "../../components/Layouts/MainSidebar.vue";
import CreateIncomeForm from "../../components/Income/CreateIncome/CreateIncomeForm.vue";
import CreateIncomeCategoryModal from "../../components/Income/IncomeCategory/CreateCategoryModal.vue";
import { useIncomeForm } from "../../composables/useIncomeForm";

export default defineComponent({
  name: "CreateIncomePage",
  components: { MainHeader, MainSidebar, BreadcrumbMenu, CreateIncomeForm, CreateIncomeCategoryModal, MainFooter },
  setup() {
    return useIncomeForm();
  },
});
</script>
